import { useCallback, useState } from "react";
import PreFilter from "../../../components/BuilderComponents/PreFilters/PreFilter";
import Button from "../../../components/FormComponents/Button";
import { useAppBlocksContext } from "../../../context/AppBlocksContext";
import useZTheme from "../../../hooks/useZTheme";
import BuilderRightSideBar from "../../../Layouts/BuilderRightSideBar";
import { elementConfig } from "../../../utils/Config/DefaultConfig/elementConfig";
import { chart_sidebar_elements } from "../../../utils/sidebarElementList";
import PositionScreenWithEdit from "../../FlexibleLayout/PositionScreenWithEdit";
import { getOffset, getPositionedElementConfig, getScreenWidth } from "../../FlexibleLayout/utils";
import { RvElementBar } from "../RecordsViewRenderer/Desktop/PositionedDesktopRecordview";
import { ChartBlockPageActionsHandler } from "./ChartRenderer";

const PositionChartBlock = () => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [selectedItem, setSelectedItem] = useState(null);
  //   const [layout, setLayout] = useState([]);
  const { applicationBlockData, layoutConfig, setLayoutConfig, chartGlobalFilter, setChartGlobalFilter } =
    useAppBlocksContext();
  const [isEditOpen, setIsEditOpen] = useState(false);

  useZTheme(applicationBlockData.device);
  const ownerPreFiltersCallBackFunction = (data) => {
    const newConfig = { ...chartGlobalFilter };
    newConfig.global_filters.owner_pre_filters = data;
    setChartGlobalFilter(newConfig);
  };

  const settingPrefiltersJoinedBy = (data) => {
    const newConfig = { ...chartGlobalFilter };
    newConfig.global_filters.prefilters_joined_by = data;
    setChartGlobalFilter(newConfig);
  };

  const settingPrefilterArray = (data) => {
    const newObj = { ...chartGlobalFilter };
    newObj.global_filters.pre_filters = data;
    setChartGlobalFilter(newObj);
  };

  const handleDragStart = useCallback(
    (e, item) => {
      const { type, chart_type, dimension } = item;

      let newConfig = getPositionedElementConfig(type, applicationBlockData.device);
      if (newConfig.type === "element") {
        newConfig.config = elementConfig[type];
        newConfig.config.dimension = dimension;
        newConfig.config.chart_type = chart_type;
      }
      const offset = getOffset(e);

      setDraggedItem(newConfig);
      setDragOffset(offset);
    },
    [applicationBlockData.device]
  );
  // const getScreenWidth = () => {
  //   if (applicationBlockData.device === "desktop") {
  //     return 1600;
  //   } else {
  //     const { grid_size, total_grid } = applicationBlockData.position_block_metadata || {};
  //     if (grid_size && total_grid) {
  //       return grid_size * total_grid;
  //     }
  //     return 0;
  //   }
  // };
  return (
    <div className="detailsView_outer_body">
      <div className="screen-center-wrapper">
        <ChartBlockPageActionsHandler />
        <div className="page-action-bar-top align_center">
          {/* <PositionScreenActionBar
            screenLayoutInfo={screenLayoutInfo}
            setScreenLayoutInfo={setScreenLayoutInfo}
            device={applicationBlockData.device}
          /> */}
          <Button onClick={() => setIsEditOpen(true)}>Prefilter</Button>
        </div>
        <div className="position-screen-center-page ">
          <PositionScreenWithEdit
            layoutConfig={layoutConfig || []}
            setLayoutConfig={setLayoutConfig}
            draggedItem={draggedItem}
            setDragOffset={setDragOffset}
            setDraggedItem={setDraggedItem}
            dragOffset={dragOffset}
            // type={screenLayoutInfo.screenMode}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            // gridSize={screenLayoutInfo.gridSize}
            screenWidth={getScreenWidth({
              device: applicationBlockData.device,
              metadata: applicationBlockData.position_block_metadata
            })}
            // showTree={screenLayoutInfo.showTree}
            // setShowTree={() => setScreenLayoutInfo({ ...screenLayoutInfo, showTree: false })}
            // showGrid={screenLayoutInfo.showGrid}
            tableId={applicationBlockData.config.table_id}
            tableType={applicationBlockData.table_type}
            device={applicationBlockData.device}
            // scaleFactor={screenLayoutInfo.scaleFactor}
            //   buttonElements={[applicationBlockData]}
            //   onClick={handleOpenCatalogView}
            //   jobPlaces="screen"
          />
        </div>
      </div>
      <div className="rightsidebar" style={{ padding: "18px" }}>
        <RvElementBar data={chart_sidebar_elements} onDragStart={handleDragStart} />
      </div>
      <BuilderRightSideBar
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        heading="Edit Prefilters"
        size="small"
      >
        <PreFilter
          table_id={applicationBlockData.config.table_id}
          activity_id={applicationBlockData.config.activity_id || ""}
          preFilters={chartGlobalFilter.global_filters.pre_filters}
          ownerPreFilters={chartGlobalFilter.global_filters.owner_pre_filters}
          setOwnerPreFilters={ownerPreFiltersCallBackFunction}
          setPreFilters={settingPrefilterArray}
          prefiltersJoinedBy={chartGlobalFilter.global_filters.prefilters_joined_by}
          setPrefiltersJoinedBy={settingPrefiltersJoinedBy}
          type={applicationBlockData.table_type}
        />
      </BuilderRightSideBar>
    </div>
  );
};

export default PositionChartBlock;
